export default __webpack_public_path__ + "static/media/Redo.5b292e7e.svg";